module.exports = __webpack_public_path__ + "img/board_thum.1b352772.png";